import { CloseIconT1 } from "../../atoms/Icon";
import { StyledFilterBadgeClearable } from "./Badge.styles";

/**
 * A small interactive badge used to indicate active filters and allow clearing them.
 *
 * Params
 * - onClickCallback (Function): Function to be called when the badge is clicked (e.g., to clear filters).
 * - count (number): The number of active filters to display inside the badge. Defaults to 0.
 * - ...props (any): Additional props passed to the `StyledFilterBadgeClearable` component.
 *
 * Returns
 * - JSX.Element: A styled badge with count and close icon that triggers a callback on click.
 */
export const FilterBadgeClearable = ({ onClickCallback, count = 0, ...props }) => {
  return (
    <StyledFilterBadgeClearable
      {...props}
      title="Clear filter"
      className="clearFilter"
      onClick={onClickCallback}
    >
      {count}
      <CloseIconT1 className="for-clear-header-filter" />
    </StyledFilterBadgeClearable>
  );
};
